//custom browser history
import { createBrowserHistory } from 'history';

export default createBrowserHistory();
